// const export const createPaymentIntent = async (paymentIntent: PaymentIntentRequest): Promise<PaymentIntentBody> => {
//   const intentData = await axios.post(`${API_DOMAIN}/api/v1/pa/payment_intents/create`, paymentIntent);
//   return intentData.data;
// };

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export type PaymentIntentRequest = {
  request_id: string
  merchant_order_id: string
  amount: number
  currency: string
  order: {
    products: {
      url: string
      name: string
      desc: string
      unit_price: number
      currency: string
      quantity: number
    }[]
  }
}
type PaymentIntentBody = {
  amount: number
  client_secret: string
  id: string
  currency: string
}

type OrderExtInfo = {
  status: string
  respCode: string
  respMsg: string
  outOrderID: string
  client_secret: string
  currency: string
  pay_type: string
  pay_amount: number
  coins: number
}

export const createPaymentIntent = createAsyncThunk(
  'wallet/createPaymentIntent',
  async (paymentIntent: PaymentIntentRequest, store: any) => {
    const resp = await http.post<{data: PaymentIntentBody}>(
      `/api/v1/pa/payment_intents/create`,
      paymentIntent
    )

    return resp.data.data
  }
)

export const get_order_ext_info = createAsyncThunk(
  'wallet/get_order_ext_info',
  async (orderId: string, store: any) => {
    const resp = await http.post<HiyaRes<OrderExtInfo>>(
      `/live/pay/get_order_ext_info`,
      {
        ...store.getState().env.deviceinfo,
        order_id: orderId,
      }
    )
    return resp.data.data
  }
)

export const AirwallexSlice = createSlice({
  name: 'Airwallex',
  initialState: {
    paymentIntent: null as PaymentIntentBody | null,
    orderExtInfo: {} as OrderExtInfo,
  },
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(createPaymentIntent.fulfilled, (state, action) => {
    //   Object.assign(state, {paymentIntent: action.payload})
    // })
    builder.addCase(get_order_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {orderExtInfo: {...action.payload}})
    })
  },
})

export default AirwallexSlice.reducer
export const AirwallexActions = AirwallexSlice.actions

export const useAirwallexState = () => {
  const data = useSelector((state) => {
    return state.Airwallex
  })
  return data
}
